import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { selectAddOnTables } from "../../../redux/selector";
import {
  EQUIPMENT_ADD_ON_TABLES,
  LOCKS_SECTION,
  PART_95_AND_ELECTRICITY_SECTIONS,
  SAFETY_AND_STANDARDS_SECTION,
  STORAGE_AND_AUXILIARY_SECTION,
  TYING_AND_LOADING_SECTION,
  TYING_STRIP_ADD_ON_TABLES,
  VEHICLE_ADD_ONS_SECTION,
} from "../data";
import TableRowModal from "./TableRowModal";
import AddOnSections from "./AddOnSections";
import AddOnTable from "./AddOnTable";
import AddTyingStripModal from "./AddTyingStripModal";
import { useStyles } from "./styles";

const AddOn = () => {
  const styles = useStyles();
  const tables = useSelector(selectAddOnTables);

  const renderTables = (tableConfigs: typeof EQUIPMENT_ADD_ON_TABLES) =>
    tableConfigs.map((tableConfig) => (
      <AddOnTable
        key={tableConfig.tableKey}
        config={tableConfig}
        rows={tables![tableConfig.tableKey]}
      />
    ));

  return (
    <>
      <AddTyingStripModal />
      <TableRowModal />
      <AddOnSections
        sections={PART_95_AND_ELECTRICITY_SECTIONS}
        hideTopBorderOnFirst
      />
      <AddOnSections sections={[TYING_AND_LOADING_SECTION]} />
      <AddOnSections sections={[STORAGE_AND_AUXILIARY_SECTION]} />
      {tables && (
        <Box className={styles.tablesWrapper}>
          {renderTables(EQUIPMENT_ADD_ON_TABLES)}
        </Box>
      )}
      <AddOnSections sections={[SAFETY_AND_STANDARDS_SECTION]} />
      {tables && (
        <Box className={styles.tablesWrapper}>
          {renderTables(TYING_STRIP_ADD_ON_TABLES)}
        </Box>
      )}
      <AddOnSections sections={[LOCKS_SECTION, VEHICLE_ADD_ONS_SECTION]} />
    </>
  );
};

export default AddOn;
